import { useTranslations } from '@vocab/react';
import { Stack, Text } from 'braid-design-system';

import {
  BRANDING_CONTEXTUAL_HELP,
  TOOLTIP_PRESSED,
} from 'src/app/shared/dataAnalytics/schema/constants';
import getTrackingAdapter from 'src/app/v1/dataAnalytics';

import { ContextualHelp } from '../../shared/ContextualHelp';

import translations from './.vocab';

export const BrandingContextualHelp = () => {
  const { t } = useTranslations(translations);

  return (
    <ContextualHelp
      ariaLabel="Job Branding Help"
      tooltipId="job-branding-help-tooltip"
      message={
        <Stack space="medium">
          <Text weight="strong">{t('branding-help-text-title')}</Text>
          <Text>{t('branding-help-text-content')}</Text>
        </Stack>
      }
      onTrigger={() =>
        getTrackingAdapter.sendLinkEvent({
          eventName: TOOLTIP_PRESSED,
          tooltipType: BRANDING_CONTEXTUAL_HELP,
        })
      }
    />
  );
};
